import axios from "axios";

type ApiErrorData = {
  message?: string;
  errors?: Record<string, string[] | string>;
};

export const getHttpStatus = (error: unknown): number | undefined =>
  axios.isAxiosError(error) ? error.response?.status : undefined;

export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!axios.isAxiosError<ApiErrorData>(error)) {
    return fallback;
  }

  const responseData = error.response?.data;

  if (!responseData) {
    return fallback;
  }

  const firstFieldError = Object.values(responseData.errors ?? {})[0];

  if (Array.isArray(firstFieldError) && firstFieldError[0]) {
    return firstFieldError[0];
  }

  if (typeof firstFieldError === "string") {
    return firstFieldError;
  }

  return responseData.message || fallback;
};
